import React from 'react';
import './Offer.scss';
import { HashLink } from 'react-router-hash-link';

const highlights = [
    {
        title: 'Dobór sprzętu',
        description: 'Doradzimy w wyborze drukarki, materiałów eksploatacyjnych i akcesoriów dopasowanych do codziennej pracy zakładu.',
    },
    {
        title: 'Konfiguracja stanowiska',
        description: 'Pomagamy ustawić urządzenia i proces pracy tak, aby Nekrodruk był gotowy do użycia bez zbędnych przestojów.',
    },
    {
        title: 'Wsparcie po wdrożeniu',
        description: 'Zostajemy z Tobą także po starcie: pomagamy rozwiązać problemy techniczne i dopracować wygodny sposób pracy.',
    },
];

export default function Offer() {
    return (
        <section className='Offer' id='Offer'>
            <div className='Offer_wrapper'>
                <div className='Offer_content'>
                    <div className='Offer_intro'>
                        <span className='Offer_kicker'>Oferta</span>
                        <h1 className='Offer_title'>Wdrożenie Nekrodruku od pierwszej rozmowy do gotowego druku</h1>
                        <p className='Offer_lead'>
                            Pomagamy dobrać narzędzia, skonfigurować stanowisko i przygotować proces pracy tak, aby tworzenie nekrologów,
                            tabliczek oraz szarf było szybkie, powtarzalne i bezpieczne dla Twojego zespołu.
                        </p>
                    </div>

                    <div className='Offer_highlights'>
                        {highlights.map((item, index) => (
                            <article className='Offer_highlight' key={item.title}>
                                <span className='Offer_highlightNumber'>{String(index + 1).padStart(2, '0')}</span>
                                <h2>{item.title}</h2>
                                <p>{item.description}</p>
                            </article>
                        ))}
                    </div>

                    <div className='Offer_footer'>
                        <p>Nie musisz samodzielnie układać całego procesu. Pokażemy, jak wdrożyć system w praktyce.</p>
                        <HashLink to={'/#Contact'} className='Offer_cta'>
                            Zapytaj o szczegółową ofertę
                        </HashLink>
                    </div>
                </div>
            </div>
        </section>
    );
}
